module.exports = __webpack_public_path__ + "img/Image2.fd15d1a4.png";